import { motion } from "framer-motion";
import Logo from "@/components/site/Logo";

const WHATSAPP_URL = "https://wa.me/918779853459";
const EMAIL = "mailto:positiveclinic@gmail.com";
const INSTAGRAM_PLST = "https://instagram.com/physioledstrengthtraining";
const INSTAGRAM_POSITIVE = "https://instagram.com/positivephysiotherapy";

const EXPLORE = [
  { to: "#why", label: "Why PLST" },
  { to: "#who", label: "Who PLST is for" },
  { to: "#process", label: "The PLST Process" },
  { to: "#services", label: "Services" },
  { to: "#team", label: "Team" },
  { to: "#faq", label: "FAQs" },
  { to: "#contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#1E1E1E] text-[#F5F4EF] pt-24 pb-10 grain-bg" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.24em] text-[#A67C00]">Physio-Led Strength Training</div>
            <h3 className="mt-6 font-display font-semibold text-4xl md:text-6xl tracking-tighter leading-[0.95] max-w-xl">
              The best program isn't the hardest one.<br />
              <span className="italic font-medium text-[#A67C00]">It's the right one.</span>
            </h3>
            <a
              href={WHATSAPP_URL}
              target="_blank" rel="noopener noreferrer"
              data-testid="footer-whatsapp-cta"
              className="group inline-flex items-center gap-2 mt-10 bg-[#A67C00] text-[#1E1E1E] px-6 py-3 text-sm font-semibold hover:bg-[#F5F4EF] transition-colors"
            >
              Talk to us <span className="transition-transform group-hover:translate-x-1">→</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.24em] text-white/50">Studios</div>
            <ul className="mt-6 space-y-5 text-sm">
              <li>
                <div className="text-[#F5F4EF]">Vile Parle East</div>
                <div className="text-white/50 text-xs mt-1">Mumbai</div>
              </li>
              <li>
                <div className="text-[#F5F4EF]">Thane West</div>
                <div className="text-white/50 text-xs mt-1">Thane</div>
              </li>
              <li>
                <div className="text-[#F5F4EF]">Andheri West — Lokhandwala</div>
                <div className="text-white/50 text-xs mt-1">Mumbai</div>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.24em] text-white/50">Explore</div>
            <ul className="mt-6 space-y-3 text-sm">
              {EXPLORE.map((l) => (
                <li key={l.to}>
                  <a href={l.to} className="hover:text-[#A67C00] transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.24em] text-white/50">Follow & Contact</div>
            <ul className="mt-6 space-y-3 text-sm">
              <li>
                <a href={INSTAGRAM_PLST} target="_blank" rel="noopener noreferrer" data-testid="footer-ig-plst" className="hover:text-[#A67C00] transition-colors">
                  PLST Instagram
                </a>
                <div className="text-[10px] text-white/40 mt-0.5">@physioledstrengthtraining</div>
              </li>
              <li>
                <a href={INSTAGRAM_POSITIVE} target="_blank" rel="noopener noreferrer" data-testid="footer-ig-positive" className="hover:text-[#A67C00] transition-colors">
                  Positive Physiotherapy Instagram
                </a>
                <div className="text-[10px] text-white/40 mt-0.5">@positivephysiotherapy</div>
              </li>
              <li className="pt-2">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#A67C00] transition-colors">WhatsApp</a>
              </li>
              <li>
                <a href={EMAIL} data-testid="footer-email" className="hover:text-[#A67C00] transition-colors">Email</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom lockup — full official PLST logo */}
        <motion.div
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6"
        >
          <div className="flex items-center gap-6">
            {/* Full logo shown on a small warm off-white plate (its designed clear-space).
                The uploaded artwork is dark-on-cream, so a cream lockup panel is the
                cleanest way to preserve the logo unaltered on a dark footer. */}
            <div className="bg-[#F5F4EF] px-5 py-3 flex items-center justify-center" aria-hidden>
              <Logo variant="full-trim" size={72} />
            </div>
            <div className="text-xs">
              <div className="text-[#F5F4EF] font-semibold tracking-[0.02em]">PLST — Physio-Led Strength Training</div>
              <div className="text-white/50 mt-1">By Positive Physiotherapy</div>
            </div>
          </div>
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} Positive Physiotherapy. All rights reserved.
          </div>
        </motion.div>
      </div>
    </footer>
  );
}

